<aca-alert-message #alertComponent></aca-alert-message>

<div class="loginBackground">
    <p-card class="loginPanel p-grid" styleClass="app-frame">
        <p-header>
            <h1 i18n="Sign In | Login Title">Sign In</h1>
        </p-header>    
        <aca-login-panel (message)="this.showError($event)"></aca-login-panel>
    </p-card>
</div>
